import {
  defaultCategories,
  CATEGORY_STANDARD,
  CATEGORY_PREMIUM,
  CATEGORY_NON_RESIDENT_STANDARD,
  CATEGORY_NON_RESIDENT_PREMIUM,
} from 'data/Pilgrims';

const categoryPairs = {
  [CATEGORY_PREMIUM]: CATEGORY_STANDARD,
  [CATEGORY_NON_RESIDENT_PREMIUM]: CATEGORY_NON_RESIDENT_STANDARD,
};

export const getAgencyCategoryOptions = (categories) =>
  defaultCategories.map((name) => categories.find((category) => category.name === name)).filter(Boolean);

const categoryId = (categories, name) => categories.find((category) => category.name === name)?.id;

// null represents the untouched initial selection; [] represents a user-cleared selection.
export const resolveAgencyCategoryIds = (value, categories) => {
  const selected = new Set(value === null || value === undefined ? [categoryId(categories, CATEGORY_STANDARD)] : value);
  Object.entries(categoryPairs).forEach(([premium, standard]) => {
    const premiumId = categoryId(categories, premium);
    if (premiumId && selected.has(premiumId)) selected.add(categoryId(categories, standard));
  });
  selected.delete(undefined);
  return [...selected];
};

export const hasAgencyCategoryDependencies = (value, categories) =>
  Object.entries(categoryPairs).every(([premium, standard]) => {
    const premiumId = categoryId(categories, premium);
    return !premiumId || !value.includes(premiumId) || value.includes(categoryId(categories, standard));
  });

export const toggleAgencyCategory = (value, category, categories) => {
  const selected = new Set(resolveAgencyCategoryIds(value, categories));
  if (selected.has(category.id)) {
    selected.delete(category.id);
    const premium = Object.entries(categoryPairs).find(([, standard]) => standard === category.name)?.[0];
    if (premium) selected.delete(categoryId(categories, premium));
  } else {
    const standard = categoryPairs[category.name];
    if (standard && !categoryId(categories, standard)) return [...selected];
    selected.add(category.id);
    if (standard) selected.add(categoryId(categories, standard));
  }
  return [...selected];
};

export const canSelectAgencyCategory = (category, categories) =>
  !categoryPairs[category.name] || !!categoryId(categories, categoryPairs[category.name]);
